const colors = {
  BRAND_PRIMARY: "#2d3A47",
  BRAND_SECONDARY: "#77b2fb",
  WEBSITE_NAVY: "#1c3c7e",

  SUCCESS: "rgb(117,183 ,134)",
  ERROR: "rgb(219,101,101)",
  WARNING: "rgb(219,165,89)",
  OFFLINE: "rgb(217, 38, 28)",

  SENSORS: {
    heating_oil: "#6B4226",
    heating_oil_el: "#704214",
    heating_oil_es: "#8B5E3C",
    heating_oil_els: "#9C6B3F",
    heating_oil_s: "#A97142",
    heating_oil_l: "#B07D48",
    heating_oil_m: "#C18F59",
    water: "#1E90FF",
    adblue: "#4682B4",
    petrol: "#FF0000",
    super: "#FF4500",
    super_plus: "#FF6347",
    e10: "#FF7F50",
    diesel: "#006400",
    hvo100: "#228B22",
    bio_diesel: "#32CD32",
    rme: "#2E8B57",
    lpg: "#800080",
    engine_oil: "#DAA520",
    used_oil: "#4B3621",
    palm_oil: "#FF8C00",
    rape_oil: "#FFD700",
    veg_oil: "#F0E68C",
    hydraulic_fluid: "#708090",
    nitrogen: "#00CED1",
    antifreeze: "#8A2BE2",
    flour: "#F5DEB3",
    rye_flour: "#C2B280",
    corn: "#FFD700",
    special: "#000000",
    1: "#ac5a54",
    2: "#706c98",
    3: "#9f7e49",
    4: "#648872"
  },
  YEARS: {
    2004: "#3A4290",
    2005: "#579583",
    2006: "#C4523C",
    2007: "#828282",
    2008: "#929626",
    2009: "#973B78",
    2010: "#DDA701",
    2011: "#648498",
    2012: "#C97931",
    2013: "#528F4F",
    2014: "#A73737",
    2015: "#3A4290",
    2016: "#579583",
    2017: "#E08898",
    2018: "#80ABD0",
    2019: "#F8453C",
    2020: "#AABB19",
    2021: "#808080",
    2022: "#3A4290",
    2023: "#87b4e7",
    2024: "#f9a23b",
    2025: "#089c85",
    2026: "#ae6612"
  },
  MESSAGE_STATUSES: {
    ok: "#43AC6A",
    error: "#f04124",
    unknown: "#ffd633",

    received: "#ffd633",
    parsed: "#ffd633",
    parsing_failed: "#f04124",
    processed: "#43AC6A",

    finalized: "#ffd633",
    released: "#ffd633",
    gateway: "#ffd633",
    sent: "#43AC6A",
    delivered: "#43AC6A",
    sending_failed: "#f04124",
    delivery_failed: "#f04124"
  },
  CHART_TEMPERATURE: {
    normal: "#43AC6A",
    cold: "#78b3fa",
    hot: "#f04124",
    line: "#000000"
  }
};

export default colors;
